import { MobileOnly } from '@/src/common/utilities/viewportDisplay'
import {
    BuildACardStep,
    SimpleFieldWrapper,
} from '@/src/modules/build-a-card/StepElement'
import {
    BOX_SELECTION,
    NO_BOX_SELECTION,
} from '@/src/modules/build-a-card/constants'
import { BOX_URL, PERSONALIZED_VISA_URL } from '@/src/modules/checkout/strings'
import DetailedOptionButton from '@/src/modules/gift-box/buttons/DetailedOptionButton'
import Link from 'next/link'
import { useState } from 'react'
import CtaButtons from '@/src/modules/gift-box/buttons/CtaButtons'
import OptionSeparator from '@/src/common/components/elements/Layout/OptionSeparator'
import { HeaderParagraphText } from '@/src/modules/build-a-card/StyledComponents'

const BoxStep1RightContent = ({
    currentStep,
}: {
    currentStep: number
    setCurrentStep: Function
}) => {
    const [selection, setSelection] = useState<
        typeof BOX_SELECTION | typeof NO_BOX_SELECTION | ''
    >('')

    return (
        <BuildACardStep active={currentStep === 1}>
            <SimpleFieldWrapper>
                <HeaderParagraphText>
                    Choose your PerfectGift bundle:
                </HeaderParagraphText>
                <Link href={`/${PERSONALIZED_VISA_URL}?step=2`} passHref>
                    <DetailedOptionButton
                        optionNumber={'1'}
                        header={'Personalize each gift'}
                        description={'Each Visa Gift Card can be customized.'}
                        image={'/images/carrier-image.png'}
                        altText={'Personalized gifts image'}
                        onClick={() => {
                            setSelection(NO_BOX_SELECTION)
                        }}
                        imageWidth={133}
                        imageHeight={166}
                        isActive={selection === NO_BOX_SELECTION}
                    />
                </Link>
                <OptionSeparator padding={'0px 7%'} />
                <Link href={`/${BOX_URL}?step=2`} passHref>
                    <DetailedOptionButton
                        optionNumber={'2'}
                        header={'PerfectGift box'}
                        description={
                            'If you need Visa gift cards quick, all the same Cards shipped same day in a box.'
                        }
                        image={'/images/gift-box-image-v2.png'}
                        altText={'PerfectGift box image'}
                        onClick={() => {
                            setSelection(BOX_SELECTION)
                        }}
                        imageWidth={176}
                        imageHeight={121}
                        isActive={selection === BOX_SELECTION}
                    />
                </Link>
                <MobileOnly>
                    <CtaButtons />
                </MobileOnly>
            </SimpleFieldWrapper>
        </BuildACardStep>
    )
}

export default BoxStep1RightContent
